import React from "react";
import Helmet from "react-helmet";
import Resume from "../settings/resume.json";
import Settings from "../settings/settings.json";

export const HelmetMeta = () => {
    return (
        <Helmet>
            <meta name="theme-color" content={Settings.colors.primary} />
            <title>{Resume.basics.name} | Computer Science at Brown</title>
            <meta name="author" content={Resume.basics.name} />
            <meta name="description" content={Resume.basics.description} />
            <meta name="keywords" content={Resume.basics.keywords} />
            <link rel="canonical" href={Resume.basics.url + "/"} />
            <meta property="og:title" content={`${Resume.basics.name} | Computer Science at Brown`} />
            <meta property="og:description" content={Resume.basics.description} />
            <meta property="og:url" content={Resume.basics.url + "/"} />
            <meta property="og:site_name" content={Resume.basics.name} />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={`${Resume.basics.name} | Computer Science at Brown`} />
            <meta name="twitter:description" content={Resume.basics.description} />
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Person",
                name: Resume.basics.name,
                alternateName: "Tom Shangguan",
                url: Resume.basics.url,
                description: Resume.basics.description,
                email: Resume.basics.email,
                affiliation: { "@type": "CollegeOrUniversity", name: "Brown University" },
                alumniOf: { "@type": "CollegeOrUniversity", name: "University of California, Santa Barbara" },
                sameAs: Resume.basics.profiles.map(profile => profile.url),
                knowsAbout: Resume.interests,
            })}</script>
        </Helmet>
    );
};
